import { Component } from '@angular/core';

@Component({
  templateUrl: './own-strategies.component.html',
  styleUrls: ['../../shared/static-pages.scss'],
  standalone: false
})
export class OwnStrategiesComponent { }
